module.exports = __webpack_public_path__ + "static/media/react-mockup.99d034b6.png";